<script lang="ts">
	//Services
	import { postReq, localReq } from '../../../../services/http';
	import { format } from '../../../../services/i18n';
	//Stores
	import {
		getDeviceStatus,
		getDeviceSettings,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Helpers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	//Design system components
	import { Button, Input, Text, toast } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);

	let settings = readDeviceSettings(id);
	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore ?? settings;
	let value = settings.longpush_time;

	let cache = value;

	let loading = false;

	const min = 1;

	const max = 43200;

	let local_ip = get_local_ip(id);

	const set_longpush_time = async () => {
		if (cache !== value) {
			let res;
			loading = true;
			if (local_ip) {
				res = await localReq(device, `${local_ip}/settings`, 'post', {
					longpush_time: value,
				});
			} else {
				res = await postReq(`/device/generic_command`, {
					payload: `{"longpush_time":${value}}`,
					command: 'longpush_time',
					id: id,
				});
			}
			if (res.isok) {
				settings.longpush_time = value;
				toast.open({
					type: 'success',
					title: $format('longpush_ms_scc_toast'),
				});
				devices_settings.update_devices_settings(id, settings);
				cache = value;
			} else {
				toast.open({ type: 'danger', title: $format('longpush_ms_err_toast') });
				value = cache;
			}
			loading = false;
		}
	};
</script>

<Text styleType="body-small" class="mb-s">
	{$format('longpush_ms_description')}
</Text>

<Input
	bind:value
	class="mb-s"
	size="m"
	type="number"
	icon="fas fa-clock"
	{min}
	{max}
	on:enter={set_longpush_time}
	id="input-4haqmhd"
	aria-label={$format('longpush_ms_description', {
		default: 'Long push time',
	})}
/>
<Button class="mt-s" {loading} width="full" size="m" on:click={set_longpush_time}>
	{$format('button_save')}
</Button>
